export const UserGroupRole = {
  /* AB#83194: Member role displays as empty string in UI but still exists in the backend */
  Member: '',
  AuthorizedDelegate: 'Authorized Delegate',
  Distributor: 'Distributor',
} as const;

export type UserGroupRole = (typeof UserGroupRole)[keyof typeof UserGroupRole];

/** Maps a backend role string to its UI constant value.
 * 'Member', unknown, and missing values map to '' — MUI skips its out-of-range
 * check for the empty string, so no MenuItem is needed for it. */
export function normalizeRole(role: string | null | undefined): UserGroupRole {
  if (role === UserGroupRole.AuthorizedDelegate || role === UserGroupRole.Distributor) return role;
  return UserGroupRole.Member;
}
